
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides",
      function () {
        return require("private-next-pages/guides/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides"])
      });
    }
  